import { useMutation } from '@tanstack/react-query'

import axios from '@pepper/utils/src/function/axios/editorInstance'
import extract from '@pepper/utils/src/function/extract'

interface Parameter {
  type: 'briefs' | 'notes'
  body: {
    company_id: string
    title?: string
    existing_doc?: {
      key: 'category'
      value: ProjectCategory
    }
    metaData?: {
      source: string
    }
  }
}

type Response = {
  id: string
}

export async function createDocument({ type, body }: Parameter) {
  try {
    const response = await axios.post(`/v1/editor/${type}`, body)
    return extract.data<Response>(response).data
  } catch (error) {
    throw new Error(extract.error(error).error)
  }
}

export function useCreatePepperDoc() {
  return useMutation({
    mutationKey: ['pepper-doc'],
    mutationFn: createDocument
  })
}
